import React, { useState, useEffect } from 'react';
import './Publishings.css';
import Footer from '../../components/Footer/Footer';
import { fetchPublications } from '../../services/api';

const Publishings = () => {
  const [currentLang, setCurrentLang] = useState(() => {
    return localStorage.getItem('selectedLanguage') || 'KU';
  });
  const [selectedPublication, setSelectedPublication] = useState(null);
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedLang = localStorage.getItem('selectedLanguage') || 'KU';
    setCurrentLang(savedLang);

    const handleLanguageChange = (event) => {
      setCurrentLang(event.detail);
      localStorage.setItem('selectedLanguage', event.detail);
    };
    window.addEventListener('languageChange', handleLanguageChange);
    return () => window.removeEventListener('languageChange', handleLanguageChange);
  }, []);

  // Fetch publications from API
  useEffect(() => {
    const loadPublications = async () => {
      try {
        setLoading(true);
        const data = await fetchPublications();
        setPublications(data);
      } catch (error) {
        console.error('Failed to load publications:', error);
        setPublications([]);
      } finally {
        setLoading(false);
      }
    };

    loadPublications();
  }, []);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setSelectedPublication(null);
      }
    };
    if (selectedPublication) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [selectedPublication]);

  // Page title translations
  const pageTitles = {
    EN: 'Our Publications',
    KU: 'بڵاوکراوەکانمان',
    AR: 'منشوراتنا',
    TR: 'Yayınlarımız'
  };

  const pageTitle = pageTitles[currentLang] || pageTitles.KU;

  // Transform API data to match component structure
  const transformedPublications = publications.map(pub => ({
    title: pub.title?.[currentLang] || pub.title?.EN || '',
    description: pub.description?.[currentLang] || pub.description?.EN || '',
    image: pub.image || ''
  }));

  return (
    <div className="publishings-page">
      <div className="container">
        <div className="publishings-content">
          {/* Title */}
          <div className="publishings-title-section">
            <h1 className="page-title">{pageTitle}</h1>
          </div>

          {/* Loading State */}
          {loading && (
            <div className="text-center py-12">
              <p className="text-gray-500">Loading publications...</p>
            </div>
          )}

          {/* Publications Grid */}
          {!loading && (
            <div className="publications-grid">
              {transformedPublications.map((publication, index) => (
                <div 
                  key={index} 
                  className="publication-card"
                  onClick={() => setSelectedPublication(publication)}
                >
                  <div className="publication-image-wrapper">
                    {publication.image ? (
                      <img 
                        src={publication.image} 
                        alt={publication.title}
                        className="publication-image"
                        loading="lazy"
                      />
                    ) : (
                      <div className="publication-image-placeholder">
                        <span>No Image</span>
                      </div>
                    )}
                    <div className="publication-overlay"></div>
                  </div>
                  <div className="publication-content">
                    <h3 className="publication-title">{publication.title}</h3>
                    <p className="publication-description">{publication.description}</p>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Empty State */}
          {!loading && transformedPublications.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-500">No publications found.</p>
            </div>
          )}
        </div>
      </div>

      {/* Publication Detail Modal */}
      {selectedPublication && (
        <div 
          className="publication-modal" 
          onClick={() => setSelectedPublication(null)}
        >
          <div 
            className="publication-modal-content" 
            onClick={(e) => e.stopPropagation()}
          >
            <button 
              className="publication-modal-close"
              onClick={() => setSelectedPublication(null)}
              aria-label="Close"
            >
              ×
            </button>
            <div className="publication-modal-image-wrapper">
              <img 
                src={selectedPublication.image} 
                alt={selectedPublication.title}
                className="publication-modal-image"
              />
            </div>
            <div className="publication-modal-info">
              <h2 className="publication-modal-title">{selectedPublication.title}</h2>
              <p className="publication-modal-description">{selectedPublication.description}</p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Publishings;

